// ── Logo Next Valley ────────────────────────────────────────────────────
// Variantes:
//   variant="mark"  → solo el monograma NV + onda (default)
//   variant="full"  → NV + wordmark "NEXT VALLEY"
//   variant="text"  → solo el wordmark
// El color se hereda vía `currentColor`, así se puede tintar con clases
// Tailwind como `text-cream-100`, `text-brand-800`, etc.

export default function Logo({ variant = 'mark', className = '', size }) {
  const baseClass = `inline-block ${className}`
  const style = size ? { width: size, height: 'auto' } : undefined

  if (variant === 'full') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 380 90"
        fill="currentColor"
        className={baseClass}
        style={style}
        role="img"
        aria-label="Next Valley Strategic Partners"
      >
        <g>
          <path d="M 5 5 L 5 65 L 18 65 L 18 28 L 38 65 L 51 65 L 51 5 L 38 5 L 38 42 L 18 5 Z" />
          <path d="M 56 5 L 70 5 L 77 47 L 84 5 L 98 5 L 84 65 L 70 65 Z" />
          <path
            d="M 4 78 Q 18 70, 32 78 T 60 78 T 88 78 T 98 78"
            stroke="currentColor"
            strokeWidth="3.5"
            fill="none"
            strokeLinecap="round"
          />
        </g>
        <text
          x="120" y="42"
          fontFamily="Anton, 'Arial Narrow', sans-serif"
          fontSize="34"
          fontWeight="700"
          letterSpacing="1.5"
        >NEXT</text>
        <text
          x="120" y="76"
          fontFamily="Anton, 'Arial Narrow', sans-serif"
          fontSize="34"
          fontWeight="700"
          letterSpacing="1.5"
        >VALLEY</text>
      </svg>
    )
  }

  if (variant === 'text') {
    return (
      <span
        className={`font-display tracking-wide leading-none ${className}`}
        style={style}
      >
        NEXT VALLEY
      </span>
    )
  }

  // Default: NV monograma + onda
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 120 90"
      fill="currentColor"
      className={baseClass}
      style={style}
      role="img"
      aria-label="Next Valley"
    >
      <path d="M 5 5 L 5 65 L 18 65 L 18 28 L 38 65 L 51 65 L 51 5 L 38 5 L 38 42 L 18 5 Z" />
      <path d="M 56 5 L 70 5 L 77 47 L 84 5 L 98 5 L 84 65 L 70 65 Z" />
      <path
        d="M 4 78 Q 18 70, 32 78 T 60 78 T 88 78 T 98 78"
        stroke="currentColor"
        strokeWidth="3.5"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  )
}
